/**
 * Associate Party
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const AssociatePartyState = {}

export const AssociatePartyActions = {
  async unassociateParty (_, requestData) {
    return axiosRequest.
      delete(`/records/${requestData.recordId}/parties/${requestData.partyId}`).
      catch(handleError)
  },

  partyHasScheduledTextMessages: async (_, { partyId, recordId }) => {
    return axiosRequest.
      get(`/records/${recordId}/parties/${partyId}/has_scheduled_text_messages`).
      then(({ data }) => data.has_scheduled_text_messages).
      catch(handleError)
  },
}

export const AssociatePartyMutations = {}

export const AssociatePartyGetters = {}
